import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import { Column, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { MessageFrame } from './MessageFrame';
import { MessageScrollArea } from './MessageScrollArea';
import { ProposalActionsRow } from './ProposalActionsRow';
import { ProposalItemCheckbox } from './ProposalItemCheckbox';
import scrollAreaStyles from './scrollArea.module.scss';
export const GetListSelectMultiMessageTID = (parentTestId)=>getTestIds(parentTestId);
export const ListSelectMultiMessage = (param)=>{
    let { content, messageId, interactive, onDismiss, onApply } = param;
    const { ListSelectMultiMessageTID } = useMemo(()=>GetListSelectMultiMessageTID(messageId), [
        messageId
    ]);
    const [itemChecked, setItemChecked] = useState(()=>{
        const initial = {};
        content.items.forEach((i)=>initial[i.id] = i.checked);
        return initial;
    });
    const toggleItem = (itemId)=>setItemChecked((prev)=>_object_spread_props(_object_spread({}, prev), {
                [itemId]: !prev[itemId]
            }));
    const selectedItemIds = content.items.map((i)=>i.id).filter((id)=>itemChecked[id]);
    return /*#__PURE__*/ _jsx(Column, {
        gap: 12,
        width: "100%",
        className: scrollAreaStyles.fillSlot,
        children: /*#__PURE__*/ _jsxs(MessageFrame, {
            testId: ListSelectMultiMessageTID.Root(),
            padding: "16px 0 0 0",
            fillHeight: true,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: ListSelectMultiMessageTID.Intro(),
                    className: scrollAreaStyles.framePad,
                    children: content.intro
                }),
                content.question !== content.intro && /*#__PURE__*/ _jsx(Typography, {
                    testId: ListSelectMultiMessageTID.Question(),
                    className: scrollAreaStyles.framePad,
                    children: content.question
                }),
                /*#__PURE__*/ _jsx(MessageScrollArea, {
                    testId: ListSelectMultiMessageTID.Items(),
                    gap: 8,
                    padBottom: false,
                    children: content.items.map((item)=>/*#__PURE__*/ _jsx(ProposalItemCheckbox, {
                            item: item,
                            checked: !!itemChecked[item.id],
                            disabled: !interactive,
                            onChange: ()=>toggleItem(item.id),
                            testId: ListSelectMultiMessageTID.Item(item.id)
                        }, item.id))
                }),
                interactive && /*#__PURE__*/ _jsx(ProposalActionsRow, {
                    className: scrollAreaStyles.frameFooter,
                    selectedCount: selectedItemIds.length,
                    applySelectedLabel: content.addSelectedLabel,
                    dismissLabel: content.dismissLabel,
                    applySelectedDisabled: selectedItemIds.length === 0,
                    onApplySelected: ()=>onApply(messageId, selectedItemIds),
                    onDismiss: ()=>onDismiss(messageId),
                    dismissTestId: ListSelectMultiMessageTID.Dismiss(),
                    applySelectedTestId: ListSelectMultiMessageTID.AddSelected()
                })
            ]
        })
    });
};
